import api from './apiClient';

// Fetch menu structure
export const getMenu = async () => {
  try {
    console.log('Fetching menu from API');
    const response = await api.get('/menu/');
    console.log('Menu data received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching menu:', error);
    throw error;
  }
};

// Fetch all services from the database
export const getServices = async () => {
  try {
    console.log('Fetching services from API');
    const response = await api.get('/services/');
    console.log('Services data received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Fetch services menu structure
export const getServicesMenu = async () => {
  try {
    console.log('Fetching services menu from API');
    const response = await api.get('/services/menu/');
    console.log('Services menu received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching services menu:', error);
    throw error;
  }
};

// Fetch a single service by ID
export const getServiceById = async (id) => {
  try {
    const response = await api.get(`/services/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching service with id ${id}:`, error);
    throw error;
  }
};

// Fetch services by category
export const getServicesByCategory = async (category) => {
  try {
    const response = await api.get(`/services/by-category/${category}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching services for category ${category}:`, error);
    throw error;
  }
};

// Get services grouped by category
export const getServicesGroupedByCategory = async () => {
  try {
    console.log('Fetching services grouped by category from API');
    const response = await api.get('/services/categories/');
    console.log('Services grouped by category received:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching services grouped by category:', error);
    throw error;
  }
};

export const getServicesByProvider = async (provider) => {
  try {
    console.log(`Fetching services for provider ${provider} from API`);
    const response = await api.get(`/services/by-provider/${provider}/`);
    console.log(`Services for provider ${provider} received:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching services for provider ${provider}:`, error);
    throw error;
  }
};

// Fetch attributes for a specific category
export const getAttributesForCategory = async (category) => {
  try {
    console.log(`Fetching attributes for category ${category} from API`);
    const response = await api.get(`/services/attributes/${category}`);
    console.log(`Attributes for category ${category} received:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching attributes for category ${category}:`, error);
    throw error;
  }
};

// Subscribe to newsletter
export const subscribeToNewsletter = async (data) => {
  try {
    console.log('Subscribing to newsletter:', data);
    const response = await api.post('/newsletter/subscribe/', data);
    console.log('Newsletter subscription successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error subscribing to newsletter:', error);
    throw error;
  }
};

// Subscribe to deadline alerts
export const subscribeToDeadlineAlerts = async (data) => {
  try {
    console.log('Subscribing to deadline alerts:', data);
    const response = await api.post('/deadline-alerts/subscribe/', data);
    console.log('Deadline alerts subscription successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error subscribing to deadline alerts:', error);
    throw error;
  }
};

// Send perk provider submission
export const sendPerkProviderForm = async (data) => {
  try {
    console.log('Sending perk provider form:', data);
    const response = await api.post('/messages/', data);
    console.log('Perk provider form sent successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error sending perk provider form:', error);
    throw error;
  }
};

// Reader question from a blog post (same /messages/ intake as the contact form).
export const sendBlogQuestion = async (data) => {
  const response = await api.post('/messages/', data);
  return response.data;
};

export const sendCampaignLead = async (data) => {
  try {
    const response = await api.post('/messages/', data);
    return response.data;
  } catch (error) {
    console.error('Error sending campaign lead:', error);
    throw error;
  }
};

export const getPages = () => api.get('/pages/').then(res => res.data);
export const updatePage = (id, data) => api.put(`/pages/${id}/`, data);
export const updateService = (id, data) => api.put(`/services/${id}/`, data);
export const signup = (data) => api.post('/users/signup/', data);
export const signin = (data) => api.post('/users/signin/', data);

// PUBLIC FILES API FUNCTIONS
export const getPublicFiles = async (prefix = null, recursive = false) => {
  try {
    let url = '/files/public';
    const params = new URLSearchParams();
    if (prefix) params.append('prefix', prefix);
    if (recursive) params.append('recursive', 'true');
    if (params.toString()) url += `?${params.toString()}`;
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching public files:', error);
    throw error;
  }
};

export const downloadPublicFile = async (filename) => {
  try {
    const response = await api.get(`/files/public/${filename}`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error(`Error downloading public file ${filename}:`, error);
    throw error;
  }
};

export const uploadPublicFile = async (file, folder = null) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (folder) formData.append('folder', folder);
    
    const response = await api.post('/files/public/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading public file:', error);
    throw error;
  }
};

export const deletePublicFile = async (filename) => {
  try {
    const response = await api.delete(`/files/public/${filename}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting public file ${filename}:`, error);
    throw error;
  }
};

// FORMS LIBRARY API FUNCTIONS
export const getFormsLibrary = async (prefix = null, recursive = false) => {
  try {
    let url = '/files/forms';
    const params = new URLSearchParams();
    if (prefix) params.append('prefix', prefix);
    if (recursive) params.append('recursive', 'true');
    if (params.toString()) url += `?${params.toString()}`;
    
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching forms library:', error);
    throw error;
  }
};

export const downloadForm = async (filename) => {
  try {
    const response = await api.get(`/files/forms/${filename}`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error(`Error downloading form ${filename}:`, error);
    throw error;
  }
};

export const uploadForm = async (file, folder = null) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    if (folder) formData.append('folder', folder);
    
    const response = await api.post('/files/forms/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading form:', error);
    throw error;
  }
};

export const deleteForm = async (filename) => {
  try {
    const response = await api.delete(`/files/forms/${filename}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting form ${filename}:`, error);
    throw error;
  }
};

// VAULT (PRIVATE FILES) API FUNCTIONS
export const getVaultFiles = async () => {
  try {
    const response = await api.get('/vault/files');
    return response.data;
  } catch (error) {
    console.error('Error fetching vault files:', error);
    throw error;
  }
};

export const downloadVaultFile = async (filename) => {
  try {
    const response = await api.get(`/vault/files/${filename}`, {
      responseType: 'blob'
    });
    return response;
  } catch (error) {
    console.error(`Error downloading vault file ${filename}:`, error);
    throw error;
  }
};

export const uploadVaultFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await api.post('/vault/files', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error uploading vault file:', error);
    throw error;
  }
};

export const deleteVaultFile = async (filename) => {
  try {
    const response = await api.delete(`/vault/files/${filename}`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting vault file ${filename}:`, error);
    throw error;
  }
};

// BLOG API FUNCTIONS
export const getBlogPosts = async () => {
  try {
    const response = await api.get('/blog/posts');
    return response.data;
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
};

export const getBlogPostBySlug = async (slug) => {
  try {
    const response = await api.get(`/blog/posts/${slug}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching blog post '${slug}':`, error);
    throw error;
  }
};

export default {
  getMenu,
  getServices,
  getServiceById,
  getServicesByCategory,
  getServicesGroupedByCategory,
  getServicesByProvider,
  getServicesMenu,
  getAttributesForCategory,
  subscribeToNewsletter,
  subscribeToDeadlineAlerts,
  sendPerkProviderForm,
  getPublicFiles,
  downloadPublicFile,
  uploadPublicFile,
  deletePublicFile,
  getFormsLibrary,
  downloadForm,
  uploadForm,
  deleteForm,
  getVaultFiles,
  downloadVaultFile,
  uploadVaultFile,
  deleteVaultFile,
  getBlogPosts,
  getBlogPostBySlug
};
